import { Close, DownloadOutlined } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";

export const FileCard = ({ title, value, file, onClose }) => {
  return (
    <Box
      sx={{
        background: "#F5F5F5",
        borderRadius: 2,
        py: 1,
        px: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 1,
        mt: 1,
      }}
    >
      <Box>
        <Typography variant="body2" color="rgba(0,0,0,0.5)">
          {title}
        </Typography>
        {/* {onClose ? <Typography variant="body1">{value ? value : "NA"}</Typography> : <Typography variant="body1" sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxHeight: "50px"
        }}>{value ? value : "NA"}</Typography>} */}
      </Box>
      {file && (
        <Box display="flex" gap={1}>
          <a href={file} target="_blank" rel="noopener noreferrer">
            <IconButton>
              <DownloadOutlined color="secondary" />
            </IconButton>
          </a>
          {onClose && <IconButton onClick={onClose}>
            <Close color="secondary" />
          </IconButton>}
        </Box>
      )}
    </Box>
  );
};